<div
    [ngClass]="{
        'plus': eventData.EA === VALUE_SIGN.EventFuelRefuelling,
        'minus': eventData.EA === VALUE_SIGN.EventFuelLoss
    }"
    class="item"
>
    <div class="item__left">
        <div class="item__triangle"></div>
        <span>
            {{ eventData.EA === VALUE_SIGN.EventFuelRefuelling ? '+' : '-' }} {{ valueLFuel | number:'1.0-0' }} L {{ invoiceDiff }}
        </span>
    </div>
    <div class="item__right">
        <span class="item__title">
            {{ vehicle?.Nm }}
        </span>
        <span 
            [routerLink]="['/panel' , 'driver']"
            [queryParams]="{mode:'details', id: eventData?.DI}"
            class="item__desc"
        >
            {{ driver?.FN }} {{ driver?.LN }}
        </span>
    </div>
    <span class="item__time">
        {{ eventData.TS | date : 'HH:mm' }}
    </span>
</div>
